import React from 'react';

import { btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';

import * as ST from './styled';

interface ICardProps {
    title: string,
    text: string,
    bgImage1?: string,
    bgImageM?: string,
    image?: string,
    isVertical?: boolean,
    btnText?: string,
    btnHref?: string,
    onClick?: () => void,
    isBottomText?: boolean,
}

export const Card = (props: ICardProps): JSX.Element => {
    const { title, text, bgImage1, bgImageM, image, isVertical, btnText, btnHref, onClick, isBottomText } = props;

    return (
        <ST.Card
            isVertical={isVertical}
            isBottomText={isBottomText}
            bgImage1={bgImage1 || ''}
            bgImageM={bgImageM || ''}
        >
            <ST.DescriptionWrap isOnlyText={!image} isBottomText={isBottomText} isVertical={isVertical}>
                <ST.Title dangerouslySetInnerHTML={{ __html: title }}/>
                <ST.Text dangerouslySetInnerHTML={{ __html: text }}/>
                {btnText &&
                    <ST.Button
                        type={btnTypes.PRIMARY}
                        href={btnHref}
                        onClick={onClick}
                    >
                        {btnText}
                    </ST.Button>
                }
            </ST.DescriptionWrap>
            {image &&
                <ST.ImageWrap>
                    <ST.Image
                        src={image}
                    />
                </ST.ImageWrap>
            }
        </ST.Card>
    );
};

export default React.memo(Card);
